<template>
  <!--主体内容-->
  <div>
    <!--顶部广告-->
    <!--<div class="ad-picture">-->
    <!--<img src="../assets/xiangmuluyan.png">-->
    <!--</div>-->
    <!--中间列表-->
    <div class="content">
      <!--      筛选条件，开始-->
      <div class="card_type">
        <dl class="l-fix" style="line-height:46px;">
          <dt>
            所在地区
          </dt>
          <dd>
            <a class="more" v-on:click="clickMore($event)">
              <i class="down"></i>
            </a>
            <ul class="clearFix sheng" style="width:1020px;height:46px;overflow: hidden;">
              <li class="province" v-on:click="clickProvince($event)">
                <a class="on" href="javascript:void(0)"><span>全国</span></a>
              </li>
              <li class="province " v-for="area in areaList" v-on:click="clickProvince($event)"><a
                href="javascript:void(0)"><span>{{area.tagname}}</span></a></li>
            </ul>
          </dd>
        </dl>
      </div>
      <!--      筛选条件，结束-->
      <div style="min-height: 500px;">
        <div v-if="totalData>0">
          <div class="road-show" v-for="road in roadList">
            <a href="javascript:void(0);" target="_blank">
              <div class="road-show-left">
                <!--此处放项目图片-->
                <a target="_blank" v-if="road.outsiteurl!='' && road.outsiteurl!=null" v-bind:href="road.outsiteurl">
                  <img :src="road.imgurl">
                </a>
                <router-link target="_blank" v-else :to="{path:'/roadShowDetail',query: {id: road.id}}">
                  <img :src="road.imgurl">
                </router-link>
              </div>
              <div class="road-show-right">
                <div class="road-show-title">
                  <a target="_blank" v-if="road.outsiteurl!='' && road.outsiteurl!=null" v-bind:href="road.outsiteurl">
                    {{road.title|maxLength18}}
                  </a>
                  <router-link target="_blank" v-else :to="{path:'/roadShowDetail',query: {id: road.id}}">
                    {{road.title|maxLength18}}
                  </router-link>
                </div>
                <div class="road-show-top">
                  <div v-if="road.price!='' && road.price!=null">
                    挂牌价格：
                    <span class="price">{{road.price}}</span>
                    万
                  </div>
                  <div v-else>
                    挂牌价格：待定
                  </div>
                  <div v-if="road.capital!='' && road.capital!=null">
                    注册资本：{{road.capital}} 万
                  </div>
                  <div v-else>
                    注册资本：待定
                  </div>
                  <div>
                    标的所在地区: {{road.location}}
                  </div>
                </div>
                <div  class="road-show-bottom">
                  <div>
                    交易机构名称： {{road.exchangename}}
                  </div>
                  <div>
                    交易机构电话： {{road.telephone}}
                  </div>
                </div>
              </div>
            </a>
          </div>
        </div>
        <div style="text-align: center;margin-top:50px;" v-else-if="totalData==0">
          <img src="../assets/no-data.png">
        </div>
      </div>


      <div id="promptInfo" style="text-align: center;color:#666;margin-top:20px;"></div>
    </div>
  </div>
  <!--End:主体内容-->
</template>

<style scoped>
  @import "../style/common.css";
</style>
<script>
  import global from '../components/public/Common.vue';
  export default {
    name: 'point',
    computed: {

    },
    data() {
      return {
        serviceUrl:global.serviceUrl,
        token:global.token,
        orgid:global.orgid,
        areaList:[],
        zone:'',
        pageIndex:1, //当前页数，默认为1
        totalIndex:0, //总页数
        totalData:0, //总记录数
        roadList: [],//数组，存储记录
        noMore:false,    //没有更多了
        lock:false       //锁，防止滚动到最后时多次执行加载
      }
    },
    created: function () {
      let _this = this;
      //查询地区
      $.ajax({
        url: global.tagListUrl,
        type: 'post',
        dataType: 'jsonp',
        data: {token:global.token,"orgid":global.orgid},
        success: function (data) {
          if (data.msg == 200) {
            //第一次进页面查询地区
            _this.areaList = data.result.data.loc;
          } else {
            alert(data.msg);
          }
        },
        error: function (data) {

        }
      });

      //首次进入页面，获取第一页数据
      //loadData(this,this.pageIndex,this.serviceUrl,this.token,this.zone);
      this.loadData();

      // window.addEventListener('scroll',this.scrollEnd);//下拉加载数据
      if (document.addEventListener) {
        //webkit
        document.addEventListener('mousewheel', this.scrollEnd, false);
        //firefox
        document.addEventListener('DOMMouseScroll', this.scrollEnd, false);

      }else if(window.attachEvent){//IE
        document.attachEvent('onmousewheel',this.scrollEnd);
      }

      //触摸屏下拉加载
      var startX;                     //触摸起始横坐标
      var startY;                    //触摸起始纵坐标
      var moveSpave;                //移动的距离
      var isMoveX = true;          //判断是否为左右移动
      var isFirst = true;          //是否要判断touchmove方向
      var beginTime = 0;
      //监听 触摸事件
      document.querySelector("body").addEventListener('touchstart', function (event) {
        startX = event.targetTouches[0].pageX; //触摸起始位置赋值 相对于屏幕的 横向坐标
        startY = event.targetTouches[0].pageY; //触摸起始位置赋值 相对于屏幕的 纵向坐标
        isFirst = true;
        beginTime = new Date().getTime();
      });
      //监听 触摸滑动事件
      document.querySelector("body").addEventListener('touchmove', function (e) {
        var moveX = e.targetTouches[0].pageX; //触摸的位置   相对于屏幕的 横向坐标
        var moveY = e.targetTouches[0].pageY; //触摸的位置   相对于屏幕的 纵向坐标
        if (isFirst) {
          Math.abs(moveX - startX) - Math.abs(moveY - startY) >= 2 ? isMoveX = true : isMoveX = false;
          isFirst = false;
          //return;
        }
        if (isMoveX) {
          //水平滑动
          moveSpave = moveX - startX;
        } else {
          //竖直滑动
          moveSpave = moveY - startY;
          if (moveSpave > 0) {
            //$('.preloader').addClass('visible');
          } else {
            //$('.addajax').addClass('visible');
          }
        }
      });

      //监听触摸离开事件
      document.querySelector("body").addEventListener('touchend', function (e) {
        var endtime = new Date().getTime();
        if ((endtime - beginTime) < 100) {
          //时间小于0.1秒
          return;
        } else {
          if (isMoveX) { //当是水平拖动操作的时候
            if (moveSpave < 0) {
            } else if (moveSpave > 0) {
            }
          } else {
            //alert("垂直拖动");
            if (moveSpave < 0) {  //向上滑动
              //alert("000");
              if (_this.noMore) {
                return false;
              }
              if (!_this.lock) {
                _this.lock = true;//锁住
                _this.getMore();
              }
            } else if (moveSpave > 0) { //向下滑动  加载数据}
            }
          }
        }
      });
    },
    mounted: function () {
      //在线客服
      // const oScript = document.createElement('script');
      // oScript.type = 'text/javascript';
      // oScript.src = 'https://qiyukf.com/script/114476681b34a2798e2b4dabdd9b9235.js';
      // document.body.appendChild(oScript);
    },
    methods: {
      clickMore:function(event){
        if ($(event.currentTarget).next().height() > 100) {
          $(event.currentTarget).find("i").removeClass("up").addClass("down");
          $(event.currentTarget).next().css({"height": "46px", "overflow": "hidden"});
        } else {
          $(event.currentTarget).find("i").removeClass("down").addClass("up");
          $(event.currentTarget).next().css({"height": "114px"});
        }
      },
      clickProvince: function (event) {
        $(event.currentTarget).find("a").addClass("on");
        $(event.currentTarget).siblings().find("a").removeClass('on');
        if ($(event.currentTarget).find("a span").text() == "全国") {
          this.zone = '';
          $(".search-nav-item.province").css("display", "none").find("span").html("");
        } else {
          this.zone = $(event.currentTarget).find("a span").text();
          $(".search-nav-item.province").css("display", "inline-block").find("span").html(this.zone);
        }
        //loadData(this,this.pageIndex,this.serviceUrl,this.token,this.zone);
        this.loadData();
      },
      scrollEnd(e){

        e = e || window.event;
        if (e.wheelDelta) {  //判断浏览器IE，谷歌滑轮事件
          if (e.wheelDelta > 0) { //当滑轮向上滚动时
            // alert("滑轮向上滚动");
          }
          if (e.wheelDelta < 0) { //当滑轮向下滚动时
            //alert("滑轮向下滚动");
            // 判断是否滚动到底部
            var scrollTopHeight = parseInt(document.documentElement.scrollTop);
            var scrollTopBodyHeight = parseInt(document.body.scrollTop);
            var offsetHeight = document.body.offsetHeight;
            if (( scrollTopHeight|| parseInt(window.pageYOffset) || scrollTopBodyHeight) + window.innerHeight >= offsetHeight-20) {
              if (this.noMore) {
                return false;
              }
              if (!this.lock) {
                this.lock = true;//锁住
                this.getMore();
              }
            }

          }
        } else if (e.detail) {  //Firefox滑轮事件
          if (e.detail> 0) { //当滑轮向上滚动时
            //alert("滑轮向上滚动");
            // 滚动的高度
            var scrollTopHeight = parseInt(document.documentElement.scrollTop);
            var scrollTopBodyHeight = parseInt(document.body.scrollTop);
            var offsetHeight = document.body.offsetHeight;
            if (( scrollTopHeight|| parseInt(window.pageYOffset) || scrollTopBodyHeight) + window.innerHeight >= offsetHeight-20) {
              if (this.noMore) {
                return false;
              }
              if (!this.lock) {
                this.lock = true;//锁住
                this.getMore();
              }
            }

          }
          if (e.detail< 0) { //当滑轮向下滚动时
            //alert("滑轮向下滚动");
          }
        }
      },
      getMore() {
        // 获取更多列表，就是后台提供的获取列表接口
        var _this = this;
        this.pageIndex = this.pageIndex + 1;
        $("#promptInfo").html("数据加载中...");

        this.$http.jsonp(global.serviceUrl, {
          params: {
            'token':_this.token,
            'catid':41,
            "orgid":_this.orgid,
            'pageIndex':_this.pageIndex,
            'pageSize':10,
            'zone':_this.zone
          },
          type: 'post'
        }).then(function (response) {
          if (response.body.msg == 200) {
            _this.roadList = _this.roadList.concat(response.body.result.data);
            $("#promptInfo").html("");
            //_this.page++;

            if (_this.pageIndex == response.body.result.totalPage) {
              _this.noMore = true;//没有更多了
              $("#promptInfo").html("------没有更多了------");
            }
          } else {
            console.log('获取列表信息失败，请重试');
          }
        }).catch(function (error) {
          console.log(error);
        }).finally(function () {
          _this.lock = false;//解锁
        });

      },
      loadData:function(){
        var _this = this;
        $.ajax({
          url: global.serviceUrl+'/',
          type: 'post',
          dataType: 'jsonp',
          data: {
            'token':_this.token,
            'catid':41,
            "orgid":_this.orgid,
            'pageIndex':_this.pageIndex,
            'pageSize':10,
            'zone':_this.zone
          },
          success: function (data) {
            //console.log(data);
            if (data.msg == 200) {
              _this.totalIndex = data.result.totalPage;
              _this.totalData = data.result.totalData;

              //添加数据
              _this.roadList = data.result.data;

              if (data.result.totalPage==1) {
                //总页数为1，则没有更多了
                _this.noMore = true;//没有更多了
              }

            } else {
              alert(data.msg);
            }

          },
          error: function (data) {
            _this.lock = true;//解锁
          }
        });
      }
    },
    destroyed(){
      window.removeEventListener('scroll', this.scrollEnd);//监听页面滚动事件
    },
    filters: {
      maxLength18:function(val){
        return global.maxLength18(val)
      }
    },
  }
</script>

<style lang="stylus">

</style>



// WEBPACK FOOTER //
// src/components/Point.vue